import { check, is } from '../../../../core/utils';
import { TAG_DISPLAY_NAME } from './Constants';

export default function validateProps(props) {
    const {
        name,

        head,
        headBold,
        headFontColor,
        headOblique,

        bodyAlign,
        bodyBold,
        bodyFontColor,
        bodyOblique,
        bodyStyleFilter,

        tail,
        tailAlign,
        tailBold,
        tailFontColor,
        tailOblique,

        width,
        widthFixed,

        readonly,
        cellReadonlyFilter,
        required,
        hidden,

        onChange,
        onBlur,

        code,
        prefix,
        excludeCodes,
        cellCodeFilter,
        arrayCode,

        ...invalidProps
    } = props;

    check(name, is.notUndef, `<${TAG_DISPLAY_NAME}>：name 属性为必填项，请检查!`);
    check(
        name,
        is.string,
        `<${TAG_DISPLAY_NAME}>：name 属性必须为 String 类型，当前传入【值: ${name}、类型: ${typeof name}】，请检查!`
    );

    // head...
    check(
        head,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：head 属性可以不填或填入 String 类型，当前传入【值: ${head}、类型: ${typeof head}】，请检查!`
    );
    check(
        headBold,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：headBold 属性可以不填或填入boolean类型，当前传入【值: ${headBold}、类型: ${typeof headBold}】，请检查!`
    );
    check(
        headFontColor,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：headFontColor 属性可以不填或填入 String 类型，当前传入【值: ${headFontColor}、类型: ${typeof headFontColor}】，请检查!`
    );
    check(
        headOblique,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：headOblique 属性可以不填或填入boolean类型，当前传入【值: ${headOblique}、类型: ${typeof headOblique}】，请检查!`
    );

    // body...
    check(
        bodyAlign,
        is.undefOrOneOf('left', 'center', 'right'),
        `<${TAG_DISPLAY_NAME}>：bodyAlign 属性可以不填或填入 "left"、"center"、"right" 其中之一，当前传入【值: ${bodyAlign}、类型: ${typeof bodyAlign}】，请检查!`
    );
    check(
        bodyBold,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：bodyBold 属性可以不填或填入boolean类型，当前传入【值: ${bodyBold}、类型: ${typeof bodyBold}】，请检查!`
    );
    check(
        bodyFontColor,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：bodyFontColor 属性可以不填或填入 String 类型，当前传入【值: ${bodyFontColor}、类型: ${typeof bodyFontColor}】，请检查!`
    );
    check(
        bodyOblique,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：bodyOblique 属性可以不填或填入boolean类型，当前传入【值: ${bodyOblique}、类型: ${typeof bodyOblique}】，请检查!`
    );
    check(
        bodyStyleFilter,
        is.undefOrFunc,
        `<${TAG_DISPLAY_NAME}>：bodyStyleFilter 属性可以不填或填入 function 类型，当前传入【值: ${bodyStyleFilter}、类型: ${typeof bodyStyleFilter}】，请检查!`
    );

    // tail...
    check(
        tail,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：tail 属性可以不填或填入 String 类型，当前传入【值: ${tail}、类型: ${typeof tail}】，请检查!`
    );
    check(
        tailAlign,
        is.undefOrOneOf('left', 'center', 'right'),
        `<${TAG_DISPLAY_NAME}>：tailAlign 属性可以不填或填入 "left"、"center"、"right" 其中之一，当前传入【值: ${tailAlign}、类型: ${typeof tailAlign}】，请检查!`
    );
    check(
        tailBold,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：tailBold 属性可以不填或填入boolean类型，当前传入【值: ${tailBold}、类型: ${typeof tailBold}】，请检查!`
    );
    check(
        tailFontColor,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：tailFontColor 属性可以不填或填入 String 类型，当前传入【值: ${tailFontColor}、类型: ${typeof tailFontColor}】，请检查!`
    );
    check(
        tailOblique,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：tailOblique 属性可以不填或填入boolean类型，当前传入【值: ${tailOblique}、类型: ${typeof tailOblique}】，请检查!`
    );

    // width...
    check(
        width,
        is.undefOrNumber,
        `<${TAG_DISPLAY_NAME}>：width 属性可以不填或填入Number类型，当前传入【值: ${width}、类型: ${typeof width}】，请检查!`
    );
    check(
        widthFixed,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：widthFixed 属性可以不填或填入boolean类型，当前传入【值: ${widthFixed}、类型: ${typeof widthFixed}】，请检查!`
    );

    // readonly...
    check(
        readonly,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：readonly 属性可以不填或填入boolean类型，当前传入【值: ${readonly}、类型: ${typeof readonly}】，请检查!`
    );
    check(
        cellReadonlyFilter,
        is.undefOrFunc,
        `<${TAG_DISPLAY_NAME}>：cellReadonlyFilter 属性可以不填或填入 function 类型，当前传入【值: ${cellReadonlyFilter}、类型: ${typeof cellReadonlyFilter}】，请检查!`
    );
    check(
        required,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：required 属性可以不填或填入boolean类型，当前传入【值: ${required}、类型: ${typeof required}】，请检查!`
    );
    check(
        hidden,
        is.undefOrBool,
        `<${TAG_DISPLAY_NAME}>：hidden 属性可以不填或填入boolean类型，当前传入【值: ${hidden}、类型: ${typeof hidden}】，请检查!`
    );

    // onChange...
    check(
        onChange,
        is.undefOrFunc,
        `<${TAG_DISPLAY_NAME}>：onChange 属性可以不填或填入 function 类型，当前传入【值: ${onChange}、类型: ${typeof onChange}】，请检查!`
    );
    check(
        onBlur,
        is.undefOrFunc,
        `<${TAG_DISPLAY_NAME}>：onBlur 属性可以不填或填入 function 类型，当前传入【值: ${onBlur}、类型: ${typeof onBlur}】，请检查!`
    );

    // code...
    check(
        cellCodeFilter,
        is.undefOrFunc,
        `<${TAG_DISPLAY_NAME}>：cellCodeFilter 属性可以不填或填入 function 类型，当前传入【值: ${cellCodeFilter}、类型: ${typeof cellCodeFilter}】，请检查!`
    );
    check(
        code,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：code 属性可以不填或填入 String 类型，当前传入【值: ${code}、类型: ${typeof code}】，请检查!`
    );
    check(
        prefix,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：prefix 属性可以不填或填入 String 类型，当前传入【值: ${prefix}、类型: ${typeof prefix}】，请检查!`
    );
    check(
        excludeCodes,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：excludeCodes 属性可以不填或填入 String 类型，当前传入【值: ${excludeCodes}、类型: ${typeof excludeCodes}】，请检查!`
    );
    check(
        arrayCode,
        is.undefOrString,
        `<${TAG_DISPLAY_NAME}>：arrayCode 属性可以不填或填入 String 类型，当前传入【值: ${arrayCode}、类型: ${typeof arrayCode}】，请检查!`
    );

    const invalidPropKeys = Object.keys(invalidProps);
    if (invalidPropKeys.length) {
        throw new Error(`<${TAG_DISPLAY_NAME}>：不支持配置属性【${invalidPropKeys.join(',')}】，请检查!`);
    }
}
